export default "__VITE_ASSET__jzhGtBGp__"